export const handleInputChange = (e: React.ChangeEvent<HTMLInputElement> | { target: { name: string, value: any } }, setFormData: any) => {
    const { name, value } = e.target;
    setFormData((prev: any) => ({ ...prev, [name]: value }));
};

export const handleRangeCalendarChange = (name: string, value: any, setFormData: any) => {
    setFormData((prev: any) => ({ ...prev, [name]: value }));
};